export const tailMisc = {
  tabBottom: {
    checkins: `Check-ins`,
    checkinsProg: `À venir`,
    requests: `Demandes`,
  },
  adminNav: {
    myAccount: `Mon compte`,
  },
  loader: {
    title: `Création de votre {reason} !`,
    defaultReason: `hébergement`,
    preparing: `Nous configurons votre {reason}, veuillez patienter…`,
    calendar: `Configuration du calendrier`,
    availability: `Vérification de la disponibilité`,
    prices: `Configuration des tarifs`,
    almostDone: `Presque terminé, finalisation de votre {reason}…`,
  },
};
